// import { useThanksStore } from '../storePinia/stores/thanks';

// const { useStoresStore } = require('../storePinia/stores/stores');
// const { useCheckoutStore } = require('../storePinia/stores/checkout');
const { useCabinetStore } = require('../storePinia/stores/cabinet');

window.App.setStoreModules = function (modules) {
  if (typeof modules === 'object') {
    // eslint-disable-next-line guard-for-in
    for (const key in modules) {
      switch (key) {
        case 'footerMiniBanner':
        case 'personal':
        case 'basket':
        case 'favourite':
        case 'cities':
        case 'club':
          App.store.setStore(key, modules[key]);
          break;
        case 'cabinet':
          useCabinetStore().$patch(modules[key]);
          break;
        default:
          console.warn('not registered ', key, modules[key]);
      }
    }
  }
};

App.vue.setComponent(require('@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue').default);
App.vue.setComponent(
  require('@components/Diamonds/DiamondCertificate/DiamondCertificate.vue').default
);
